package xyz.qwewqa.relive.simulator.core.gen

/*
111:
- effect_arg1: 0
  effect_type: 0
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 9
  res_item_id: 0
  res_parameter: {}
  res_quantity: 20000
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15025
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 50
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15028
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
112:
- effect_arg1: 0
  effect_type: 0
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 9
  res_item_id: 0
  res_parameter: {}
  res_quantity: 20000
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15025
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 50
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15029
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
113:
- effect_arg1: 0
  effect_type: 0
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 9
  res_item_id: 0
  res_parameter: {}
  res_quantity: 20000
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15025
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 50
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15030
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
114:
- effect_arg1: 0
  effect_type: 0
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 9
  res_item_id: 0
  res_parameter: {}
  res_quantity: 20000
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15025
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 50
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15031
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
115:
- effect_arg1: 0
  effect_type: 0
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 9
  res_item_id: 0
  res_parameter: {}
  res_quantity: 20000
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15025
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 50
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15032
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
116:
- effect_arg1: 0
  effect_type: 0
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 9
  res_item_id: 0
  res_parameter: {}
  res_quantity: 20000
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15025
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 50
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15033
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
117:
- effect_arg1: 0
  effect_type: 0
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 9
  res_item_id: 0
  res_parameter: {}
  res_quantity: 20000
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15025
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 50
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15015
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
118:
- effect_arg1: 0
  effect_type: 0
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 9
  res_item_id: 0
  res_parameter: {}
  res_quantity: 20000
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15025
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 50
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15028
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
119:
- effect_arg1: 0
  effect_type: 0
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 9
  res_item_id: 0
  res_parameter: {}
  res_quantity: 20000
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15025
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 50
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15031
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
121:
- effect_arg1: 0
  effect_type: 0
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 9
  res_item_id: 0
  res_parameter: {}
  res_quantity: 20000
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15026
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 50
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15028
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
122:
- effect_arg1: 0
  effect_type: 0
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 9
  res_item_id: 0
  res_parameter: {}
  res_quantity: 20000
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15026
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 50
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15029
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
123:
- effect_arg1: 0
  effect_type: 0
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 9
  res_item_id: 0
  res_parameter: {}
  res_quantity: 20000
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15026
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 50
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15030
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
124:
- effect_arg1: 0
  effect_type: 0
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 9
  res_item_id: 0
  res_parameter: {}
  res_quantity: 20000
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15026
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 50
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15031
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
125:
- effect_arg1: 0
  effect_type: 0
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 9
  res_item_id: 0
  res_parameter: {}
  res_quantity: 20000
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15026
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 50
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15032
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
126:
- effect_arg1: 0
  effect_type: 0
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 9
  res_item_id: 0
  res_parameter: {}
  res_quantity: 20000
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15026
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 50
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15033
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
127:
- effect_arg1: 0
  effect_type: 0
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 9
  res_item_id: 0
  res_parameter: {}
  res_quantity: 20000
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15026
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 50
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15015
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
128:
- effect_arg1: 0
  effect_type: 0
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 9
  res_item_id: 0
  res_parameter: {}
  res_quantity: 20000
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15026
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 50
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15029
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
129:
- effect_arg1: 0
  effect_type: 0
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 9
  res_item_id: 0
  res_parameter: {}
  res_quantity: 20000
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15026
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 50
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15032
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
131:
- effect_arg1: 0
  effect_type: 0
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 9
  res_item_id: 0
  res_parameter: {}
  res_quantity: 20000
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15027
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 50
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15028
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
132:
- effect_arg1: 0
  effect_type: 0
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 9
  res_item_id: 0
  res_parameter: {}
  res_quantity: 20000
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15027
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 50
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15029
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
133:
- effect_arg1: 0
  effect_type: 0
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 9
  res_item_id: 0
  res_parameter: {}
  res_quantity: 20000
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15027
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 50
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15030
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
134:
- effect_arg1: 0
  effect_type: 0
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 9
  res_item_id: 0
  res_parameter: {}
  res_quantity: 20000
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15027
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 50
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15031
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
135:
- effect_arg1: 0
  effect_type: 0
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 9
  res_item_id: 0
  res_parameter: {}
  res_quantity: 20000
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15027
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 50
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15032
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
136:
- effect_arg1: 0
  effect_type: 0
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 9
  res_item_id: 0
  res_parameter: {}
  res_quantity: 20000
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15027
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 50
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15033
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
137:
- effect_arg1: 0
  effect_type: 0
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 9
  res_item_id: 0
  res_parameter: {}
  res_quantity: 20000
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15027
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 50
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15015
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
138:
- effect_arg1: 0
  effect_type: 0
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 9
  res_item_id: 0
  res_parameter: {}
  res_quantity: 20000
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15027
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 50
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15030
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
139:
- effect_arg1: 0
  effect_type: 0
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 9
  res_item_id: 0
  res_parameter: {}
  res_quantity: 20000
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 1
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15027
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 1
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 15
  res_item_id: 81001
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 30
- effect_arg1: 0
  effect_type: 0
  res_category: 4
  res_item_id: 0
  res_parameter: {}
  res_quantity: 50
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 0
  effect_type: 0
  res_category: 13
  res_item_id: 15033
  res_parameter: {}
  res_quantity: 1
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 12
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 11
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 13
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 14
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0
- effect_arg1: 2
  effect_type: 15
  res_category: 0
  res_item_id: 0
  res_parameter: {}
  res_quantity: 0

*/

inline val dataGenFriendshipPattern get() = """{"111":[{"effect_arg1":0,"effect_type":0,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":9,"res_item_id":0,"res_parameter":{},"res_quantity":20000},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15025,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":50},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15028,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0}],"112":[{"effect_arg1":0,"effect_type":0,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":9,"res_item_id":0,"res_parameter":{},"res_quantity":20000},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15025,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":50},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15029,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0}],"113":[{"effect_arg1":0,"effect_type":0,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":9,"res_item_id":0,"res_parameter":{},"res_quantity":20000},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15025,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":50},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15030,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0}],"114":[{"effect_arg1":0,"effect_type":0,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":9,"res_item_id":0,"res_parameter":{},"res_quantity":20000},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15025,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":50},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15031,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0}],"115":[{"effect_arg1":0,"effect_type":0,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":9,"res_item_id":0,"res_parameter":{},"res_quantity":20000},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15025,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":50},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15032,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0}],"116":[{"effect_arg1":0,"effect_type":0,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":9,"res_item_id":0,"res_parameter":{},"res_quantity":20000},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15025,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":50},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15033,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0}],"117":[{"effect_arg1":0,"effect_type":0,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":9,"res_item_id":0,"res_parameter":{},"res_quantity":20000},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15025,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":50},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15015,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0}],"118":[{"effect_arg1":0,"effect_type":0,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":9,"res_item_id":0,"res_parameter":{},"res_quantity":20000},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15025,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":50},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15028,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0}],"119":[{"effect_arg1":0,"effect_type":0,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":9,"res_item_id":0,"res_parameter":{},"res_quantity":20000},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15025,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":50},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15031,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0}],"121":[{"effect_arg1":0,"effect_type":0,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":9,"res_item_id":0,"res_parameter":{},"res_quantity":20000},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15026,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":50},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15028,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0}],"122":[{"effect_arg1":0,"effect_type":0,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":9,"res_item_id":0,"res_parameter":{},"res_quantity":20000},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15026,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":50},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15029,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0}],"123":[{"effect_arg1":0,"effect_type":0,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":9,"res_item_id":0,"res_parameter":{},"res_quantity":20000},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15026,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":50},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15030,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0}],"124":[{"effect_arg1":0,"effect_type":0,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":9,"res_item_id":0,"res_parameter":{},"res_quantity":20000},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15026,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":50},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15031,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0}],"125":[{"effect_arg1":0,"effect_type":0,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":9,"res_item_id":0,"res_parameter":{},"res_quantity":20000},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15026,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":50},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15032,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0}],"126":[{"effect_arg1":0,"effect_type":0,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":9,"res_item_id":0,"res_parameter":{},"res_quantity":20000},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15026,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":50},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15033,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0}],"127":[{"effect_arg1":0,"effect_type":0,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":9,"res_item_id":0,"res_parameter":{},"res_quantity":20000},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15026,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":50},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15015,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0}],"128":[{"effect_arg1":0,"effect_type":0,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":9,"res_item_id":0,"res_parameter":{},"res_quantity":20000},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15026,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":50},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15029,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0}],"129":[{"effect_arg1":0,"effect_type":0,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":9,"res_item_id":0,"res_parameter":{},"res_quantity":20000},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15026,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":50},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15032,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0}],"131":[{"effect_arg1":0,"effect_type":0,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":9,"res_item_id":0,"res_parameter":{},"res_quantity":20000},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15027,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":50},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15028,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0}],"132":[{"effect_arg1":0,"effect_type":0,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":9,"res_item_id":0,"res_parameter":{},"res_quantity":20000},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15027,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":50},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15029,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0}],"133":[{"effect_arg1":0,"effect_type":0,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":9,"res_item_id":0,"res_parameter":{},"res_quantity":20000},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15027,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":50},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15030,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0}],"134":[{"effect_arg1":0,"effect_type":0,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":9,"res_item_id":0,"res_parameter":{},"res_quantity":20000},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15027,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":50},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15031,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0}],"135":[{"effect_arg1":0,"effect_type":0,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":9,"res_item_id":0,"res_parameter":{},"res_quantity":20000},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15027,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":50},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15032,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0}],"136":[{"effect_arg1":0,"effect_type":0,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":9,"res_item_id":0,"res_parameter":{},"res_quantity":20000},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15027,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":50},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15033,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0}],"137":[{"effect_arg1":0,"effect_type":0,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":9,"res_item_id":0,"res_parameter":{},"res_quantity":20000},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15027,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":50},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15015,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0}],"138":[{"effect_arg1":0,"effect_type":0,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":9,"res_item_id":0,"res_parameter":{},"res_quantity":20000},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15027,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":50},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15030,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0}],"139":[{"effect_arg1":0,"effect_type":0,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":9,"res_item_id":0,"res_parameter":{},"res_quantity":20000},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":1,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15027,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":1,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":15,"res_item_id":81001,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":30},{"effect_arg1":0,"effect_type":0,"res_category":4,"res_item_id":0,"res_parameter":{},"res_quantity":50},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":0,"effect_type":0,"res_category":13,"res_item_id":15033,"res_parameter":{},"res_quantity":1},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":12,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":11,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":13,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":14,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0},{"effect_arg1":2,"effect_type":15,"res_category":0,"res_item_id":0,"res_parameter":{},"res_quantity":0}]}"""
